import { useEffect } from 'react';

/**
 * 購入済み / 新規購入の Repeater rebuild effect。
 * CRUD handlers は orchestrator の handle* を Trunking / Section に直接渡す。
 *
 * @param {Object} params
 * @param {boolean} params.addRepeater
 * @param {string} params.otherSystemId
 * @param {Object} params.gen1Order
 * @param {() => void} params.onRepeaterRebuild
 */
export function useRepeaterRebuild({
    addRepeater,
    otherSystemId,
    gen1Order,
    onRepeaterRebuild,
}) {
    useEffect(() => {
        onRepeaterRebuild();
    }, [
        gen1Order?.IncludePurchasedRepeaters,
        addRepeater,
        gen1Order?.Gen1TrunkingOrderItem?.RepeaterQty,
        gen1Order?.Gen1TrunkingOrderItem?.ExchangeRepeaterPairQty,
        otherSystemId,
        gen1Order?.Gen1TrunkingOrderItem?.RemoveRepeaterQty,
        gen1Order?.SystemType,
        gen1Order?.SystemId,
        onRepeaterRebuild,
    ]);
}
